import * as React from "react";
import { TBannerItem } from "../../../services/banner";
import ImageView from "../../../components/SmartImage";
import { CubeBannerProps } from "./RollOver";

import { LinkTargetType } from "../../../services/playground";
import { ZoomBox, ZoomCardBox, AnimationDuration } from "./styles.card";
import { ZoomContainer } from "./styles.index";

/**
 * 动画思考
 * 16s一波横向translate
 */

const { useEffect, useState } = React;
export interface ZoomCardProps extends CubeBannerProps {
	online: boolean;
}
const ZoomCard = (props: ZoomCardProps) => {
	const ZoomWrapRef: React.MutableRefObject<HTMLElement | null> = React.useRef(null);
	const [rollLen, setRollLen] = useState(0);
	const [isDraging, setDragState] = useState(false);
	const [countdown, setCountdown] = useState(AnimationDuration);
	let windowScrollTimeoutId: NodeJS.Timeout;
	useEffect(() => {
		onScroll();

		return () => {
			if (!windowScrollTimeoutId) {
				return;
			}
			clearInterval(windowScrollTimeoutId);
		};
	});

	const onTransitionEnd = (e: React.TransitionEvent<HTMLAnchorElement>) => {
		if (e.target) {
			onScroll();
		}
	};
	const onTouchStart = () => {
		if (!isDraging) {
			setDragState(true);
		}
		if (!windowScrollTimeoutId) {
			return;
		}
		clearInterval(windowScrollTimeoutId);
	};

	const onTouchEnd = () => {
		if (isDraging) {
			setDragState(false);
		}
	};
	const onTouchCancel = () => {
		if (isDraging) {
			setDragState(false);
		}
	};

	const onScroll = () => {
		if (windowScrollTimeoutId) {
			clearInterval(windowScrollTimeoutId);
		}
		windowScrollTimeoutId = setInterval(() => {
			if (isDraging) {
				return;
			}
			if (!countdown) {
				const zoomWrapObj = ZoomWrapRef.current;
				if (!zoomWrapObj) {
					return;
				}
				const zoomWrapRect = zoomWrapObj.getBoundingClientRect();
				if (
					zoomWrapObj.scrollWidth >
					(zoomWrapObj.parentElement?.clientWidth || 0) + Math.abs(zoomWrapRect.left)
				) {
					setRollLen(rollLen + 1);
				} else {
					setRollLen(0);
				}
				setCountdown(AnimationDuration);
			} else {
				setCountdown(countdown - 1);
			}
		}, 1000);
	};

	const { elements, placeholderBg, aTarget = LinkTargetType.Blank } = props;
	return (
		<ZoomBox
			ref={ZoomWrapRef}
			style={{
				transform: `translate3d(calc((100vw - 1.4rem) * ${-rollLen}/4), 0 ,0)`,
				transitionDuration: `${rollLen ? 1000 : 0}ms`,
			}}
			onTouchStart={onTouchStart}
			onTouchCancel={onTouchCancel}
			onTouchEnd={onTouchEnd}
			onTransitionEnd={onTransitionEnd}
		>
			{elements.map((element: TBannerItem, i: number) => (
				<ZoomCardBox
					key={i}
					isDraging={isDraging}
					onClick={(e) => {
						if (!element.link) {
							e.preventDefault();
						}
					}}
					{...(element.link ? { href: element.link, target: aTarget } : {})}
				>
					<ImageView
						src={element.img}
						online={props.online}
						key={i}
						style={{}}
						placeholder={placeholderBg}
						fallbackSrc={placeholderBg}
					/>
				</ZoomCardBox>
			))}
		</ZoomBox>
	);
};

const CubeBannerZoom = (props: CubeBannerProps) => {
	const { positionId } = props;

	return (
		<ZoomContainer id={positionId}>
			<ZoomCard {...props} online={props.online} />
		</ZoomContainer>
	);
};
export default CubeBannerZoom;
